// The workspace home: its navigation entry, shown inside a workspace.
import { HouseIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "home",
  group: "home",
  labelKey: "home.nav",
  icon: HouseIcon,
  to: ({ params }) => (params.workspace ? routes.home(params.workspace) : null),
  order: 10,
});
